import React, { Component, PropTypes } from 'react';
import { Menu, Icon, Table, Button, Modal, Spin, Row, Col, Input, Pagination } from 'antd';
import { formatPvCode } from 'utils/formatting';

import _ from 'lodash';
import cn from 'classnames';
// import { formItemLayout } from 'constants/layout';

import { connect } from 'react-redux';
import { getPointList, getAllPoints } from 'data/point';

import { browserHistory, Link } from 'react-router';
import Utils from 'utils/utils';
import moment from 'moment';
import { TableHelper, exportAsExcel } from 'helpers/Table';
// import Utils from 'utils/utils';

import classes from '../styles/PaymentVouchers.module.scss';

// import COLUMNS from './PVRVColumns';
import { DatePickerInput } from '../../components';

const pageLimit = 20;
const Confirm = Modal.confirm;

class PointList extends Component {
  constructor(props) {
    super(props);

    this.onInputSearch = this.onInputSearch.bind(this);
    this.onSearchInputPress = this.onSearchInputPress.bind(this);
    this.onTableChange = this.onTableChange.bind(this);

    const start = props.location.query.start ? moment(props.location.query.start, 'DD-MM-YYYY') : moment().subtract(3, 'month');
    const end = props.location.query.end ? moment(props.location.query.end, 'DD-MM-YYYY') : moment();

    this.state = {
      collapseMobile: [],
      showModal: false,
      selectedStatus: props.location.query.searchBy ? props.location.query.searchBy : 'all',
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : undefined,
      page: props.page || 1,
      displaySearchValue: '',
      searchValue: props.location.query.q ? props.location.query.q : '',
      searchBy: '',
      selectedRowKeys: [],
      start,
      end,
      loading: false,
    };
  }

  componentDidMount = async () => {
    const query = this.props.location.query;
    const points = await getPointList(query);

    this.setState({
      loading: false,
      points,
    });
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  componentWillReceiveProps(props) {
    const start = props.location.query.start ? moment(props.location.query.start, 'DD-MM-YYYY') : moment().subtract(3, 'month');
    const end = props.location.query.end ? moment(props.location.query.end, 'DD-MM-YYYY') : moment();
    const newState = {
      page: props.location.query.page ? parseInt(props.location.query.page, 10) : 1,
      selectedStatus: props.location.query.searchBy ? props.location.query.searchBy : 'all',
      sortBy: props.location.query.sortBy,
      searchValue: props.location.query.q ? props.location.query.q : '',
      start,
      end,
    };
    this.setState(newState);
  }

  componentWillUnmount() {
    if (this.backListener) {
      this.backListener();
    }
  }

  getPointList = async (query) => {
    const points = await getPointList(query);

    this.setState({ loading: false, points, ...query });
    browserHistory.push(`${this.props.location.pathname}${Utils.createQueryString(query)}`);
  };

  onChangePage = async (page) => {
    const points = await this.getPointList(_.merge(this.getCurrentQuery(), { page }));

    // this.setState({
    //   loading: false,
    //   points,
    //   page: page,
    // });
  };

  onInputSearch(event) {
    this.setState({
      displaySearchValue: event.target.value,
    });
  }

  onSearchInputPress(event) {
    if (event.charCode === 13) {
      this.onSearch();
    }
  }

  onTableChange(a, b, sorter) {
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.reloadData);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.reloadData);
    }
  }

  onFreezeOrder(id) {
    const { reloadData } = this;
    this.props.freeze(id).then(() => {
      reloadData();
    });
  }

  onUnfreezeOrder(id) {
    const { reloadData } = this;
    this.props.unfreeze(id).then(() => {
      reloadData();
    });
  }

  getCurrentQuery() {
    return {
      page: this.state.page || 1,
      searchBy: this.state.selectedStatus,
      q: this.state.searchValue,
      start: this.state.start.format('DD-MM-YYYY'),
      end: this.state.end.format('DD-MM-YYYY'),
      sortBy: this.state.sortBy,
    };
  }

  reloadData = async () => {
    const points = await this.getPointList(this.getCurrentQuery());

    // this.setState({
    //   loading: false,
    //   points,
    // });
  };

  changeFocusPage(event) {
    const status = event.key;
    this.setState({
      selectedStatus: status,
      selectedRowKeys: [],
      page: 1,
    });
    this.getRevenueSummaryList(_.merge(this.getCurrentQuery(), { searchBy: status, page: 1 })).then((response) => {
      console.log(response);
    });
  }

  showDeleteConfirm(record, msg, content) {
    Confirm({
      title: msg,
      content: content || '',
      onOk: () => this.onDelete(record),
      onCancel: this.onCancel,
    });
  }

  showConfirm(title, content = '', onOk) {
    Confirm({
      title,
      content,
      onOk,
    });
  }

  exportToExcel = async () => {
    const resultObj = await getAllPoints(this.getCurrentQuery());
    const results = resultObj.results;
    const content = results.map((singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });

    exportAsExcel({
      filename: `POINTS-${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`,
      sheetName: 'Sheet1',
      columns: this.columns,
      data: content,
    });
  };

  // menus = [
  //   { label: 'All', value: 'all', column: 'all' },
  //   { label: 'Pending transfer', value: 'pending', column: 'all' },
  //   { label: 'Already transferred', value: 'transferred', column: 'all' },
  //   { label: 'Not transferable', value: 'not_transfer', column: 'all' },
  // ];
  columns = [
    {
      ...TableHelper.datetimeColumn('Earn\nDate', 'createdAt'),
      sorter: true,
    },
    {
      ...TableHelper.datetimeColumn('Expired date', 'expired'),
      sorter: true,
    },
    {
      ...TableHelper.defaultColumn('Student', 'user'),
      render: (value, record) => {
        return <Link to={`/student/${value._id}`}>{`${value.name.first} ${value.name.last}`}</Link>;
      },
    },
    {
      ...TableHelper.defaultColumn('Order Code', 'order.code'),
      render: (value, record) => (
        <div className="no-wrap">
          {record.order ? (
            <div>
              {' '}
              <Link to={`/order/${record.order._id}`}>{value} </Link>
              {_.get(record, 'order.remark') && <Icon type="pushpin" />}
            </div>
          ) : (
            <div />
          )}
        </div>
      ),
    },
    {
      ...TableHelper.defaultColumn('Class / Remark', 'order.class.name'),
      render: (value, record) => {
        if (!record.order) {
          if (record.remark) {
            return <div>Remark: {record.remark}</div>;
          }
          return <div />;
        }
        return <Link to={`/class/${record.order.class._id}`}>{value}</Link>;
      },
    },
    {
      ...TableHelper.defaultColumn('Sche. No.', 'order.schedule.code'),
      render: (value, record) => {
        if (!record.order) {
          return <div />;
        }
        return <Link to={`/class/${record.order.class._id}/schedule/${record.order.schedule._id}`}>{value}</Link>;
      },
    },
    {
      ...TableHelper.integerColumn('T-Points', 'points'),
      sorter: true,
    },
  ];

  renderPageTopMenu() {
    return (
      <Menu onClick={this.changeFocusPage} selectedKeys={[this.state.selectedStatus]} mode="horizontal" className={classes.menu}>
        {this.menus &&
          this.menus.map((singleClass) => (
            <Menu.Item key={singleClass.value} className={classes.dashRight}>
              <div>{singleClass.label} </div>
            </Menu.Item>
          ))}
      </Menu>
    );
  }

  renderContentTable() {
    const count = _.get(this, 'state.points.count');
    const data = _.get(this, 'state.points.results');
    const content = _.map(data, (singleContent, key) => {
      if (singleContent) {
        singleContent.key = key;
      }

      return singleContent;
    });

    return (
      <div>
        <Table columns={this.columns} dataSource={content} bordered pagination={false} onChange={this.onTableChange} />
        <Pagination className={cn(classes.pagination, 'text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={count} />
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="page-header">{this.props.BreadCrumb}</div>
        <div className="content">
          <Spin tip="Loading" size="large" spinning={!!this.state.loading}>
            {this.renderPageTopMenu()}
            <div className={classes.searchContainer}>
              {/* <Row>
                <Col xs={7} className={classes.searchInputContainer}>
                  <Input prefix={<Icon type="search" />} placeholder="Search" onKeyPress={(e) => this.onSearchInputPress(e)} onChange={(e) => this.onInputSearch(e)} />
                </Col>
                <Col xs={7}>
                  <DatePickerInput start={this.state.start} end={this.state.end} onChange={(momentDates) => this.setState({ start: momentDates[0], end: momentDates[1] })} />
                </Col>
                <Button className="search-btn" onClick={this.onSearch}>
                  <Icon type="search" />
                </Button>
              </Row> */}
            </div>
            <div className="text-right">
              <a onClick={() => this.exportToExcel()}>Export to excel</a>
            </div>
            {this.renderContentTable()}
          </Spin>
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({}),
  {}, //, activeArticle, recommendArticle, unrecommendArticle, deleteArticle }
)(PointList);
